import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import * as React from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import {
  Container,
  Dropdown,
  Accordion,
  Card,
  Button,
  Form,
  Spinner,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import _ from "lodash";
import { Utils } from "../Common/Utilis";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
const { SearchBar } = Search;
let storage = JSON.parse(localStorage.getItem("storage")!);
let currentUtcTime =
  storage === null ? "America/Chicago" : (storage.currentUtcTime as any);

import "react-tabs/style/react-tabs.css";
import { UserService } from "../Common/Services/UserService";
 class LaborSlideout extends React.Component<any, any> {
  private parentScroll: any;
  private multiselectChild: any;

  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    
    // Set default values for salaried employees (40 hours per week, 80 total)
    const isNewPayroll = !this.props.laborData.payroll_id || this.props.laborData.payroll_id === 0;
    const isSalaried = this.props.laborData.employeeType && 
                      (this.props.laborData.employeeType.toLowerCase() === 'salaried' || 
                       this.props.laborData.employeeType.toLowerCase() === 'salary');
    const regular1Value = this.props.laborData.regular1;
    const regular2Value = this.props.laborData.regular2;
    
    // For new salaried payroll entries, always default to 40 hours per week (80 total)
    // This overrides any API values (like 20 hours) for new entries
    const defaultRegular1 = (isNewPayroll && isSalaried) ? '40' : Utils.formatTwo(regular1Value);
    const defaultRegular2 = (isNewPayroll && isSalaried) ? '40' : Utils.formatTwo(regular2Value);
    
    // Calculate totalHrs: for new salaried entries, total should be 80
    const defaultTotalHrs = (isNewPayroll && isSalaried) ? '80.00' : Utils.formatTwo(this.props.laborData.totalHrs);
    
    this.state = {
      biWeekly: this.props.biWeekly || true,
      formData: {
  pay_period_start: this.props.periodStartDate,
  pay_period_end: this.props.periodEndDate,
  payroll_id: this.props.laborData.payroll_id || 0,
  employee_id: this.props.laborData.empid,
  totalHrs: defaultTotalHrs,
  regular1: defaultRegular1,
  regular2: defaultRegular2,
  ot: Utils.formatTwo(this.props.laborData.ot),
  dot: Utils.formatTwo(this.props.laborData.dot),
  pto: Utils.formatTwo(this.props.laborData.pto),
  holiday: Utils.formatTwo(this.props.laborData.holiday),
  vacation: Utils.formatTwo(this.props.laborData.vacation),
  sick: Utils.formatTwo(this.props.laborData.sick),
  bonus1: Utils.formatTwo(this.props.laborData.bonus1),
  bonus2: Utils.formatTwo(this.props.laborData.bonus2),
  differential_Pay1: Utils.formatTwo(this.props.laborData.differential_Pay1),
  differential_Pay2: Utils.formatTwo(this.props.laborData.differential_Pay2),
  retroactive1: Utils.formatTwo(this.props.laborData.retroactive1),
  retroactive2: Utils.formatTwo(this.props.laborData.retroactive2),
  emp_Reimbursement1: Utils.formatTwo(this.props.laborData.emp_Reimbursement1),
  emp_Reimbursement2: Utils.formatTwo(this.props.laborData.emp_Reimbursement2),
  miscellaneous1: Utils.formatTwo(this.props.laborData.miscellaneous1),
  miscellaneous2: Utils.formatTwo(this.props.laborData.miscellaneous2),
  flex_Pay1: Utils.formatTwo(this.props.laborData.flex_Pay1),
  flex_Pay2: Utils.formatTwo(this.props.laborData.flex_Pay2),
  loan_Repayment1: Utils.formatTwo(this.props.laborData.loan_Repayment1),
  loan_Repayment2: Utils.formatTwo(this.props.laborData.loan_Repayment2),
  meal_Allowance1: Utils.formatTwo(this.props.laborData.meal_Allowance1),
  meal_Allowance2: Utils.formatTwo(this.props.laborData.meal_Allowance2),
  auto_Allowance1: Utils.formatTwo(this.props.laborData.auto_Allowance1),
  auto_Allowance2: Utils.formatTwo(this.props.laborData.auto_Allowance2),
  other_Allowance1: Utils.formatTwo(this.props.laborData.other_Allowance1),
  other_Allowance2: Utils.formatTwo(this.props.laborData.other_Allowance2),
  commission1: Utils.formatTwo(this.props.laborData.commission1),
  commission2: Utils.formatTwo(this.props.laborData.commission2),
  paycheck_Tips1: Utils.formatTwo(this.props.laborData.paycheck_Tips1),
  paycheck_Tips2: Utils.formatTwo(this.props.laborData.paycheck_Tips2),
  phone_Allowance1: Utils.formatTwo(this.props.laborData.phone_Allowance1),
  phone_Allowance2: Utils.formatTwo(this.props.laborData.phone_Allowance2),
  notes: this.props.laborData.notes || "",
}

    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (prevProps.locationId != this.props.locationId) {
      this.closeSlideOut();
    }
  }
  saveItem = () => {
    let formData = { ...this.state.formData };
    this.setState({ isSpinner: true });

    // const parsedFormData = Object.keys(formData).reduce((acc, key) => {
    //   if (key === 'notes') {
    //     acc[key] = formData[key];
    //   } else {
    //     const parsed = parseFloat(formData[key]);
    //     acc[key] = isNaN(parsed) ? 0 : parsed;
    //   }
    //   return acc;
    // }, {});

    const parsedFormData = {
      ...formData,
      ot: parseFloat(formData.ot) || 0,
      dot: parseFloat(formData.dot) || 0,
      pto: parseFloat(formData.pto) || 0,
      totalHrs: this.calculateTotalHours(),
      regular1: parseFloat(formData.regular1) || 0,
      holiday: parseFloat(formData.holiday) || 0,
      vacation: parseFloat(formData.vacation) || 0,
      sick: parseFloat(formData.sick) || 0,
      bonus1: parseFloat(formData.bonus1) || 0,
      bonus2: parseFloat(formData.bonus2) || 0,
      differential_Pay1: parseFloat(formData.differential_Pay1) || 0,
      differential_Pay2: parseFloat(formData.differential_Pay2) || 0,
      retroactive1: parseFloat(formData.retroactive1) || 0,
      retroactive2: parseFloat(formData.retroactive2) || 0,
      emp_Reimbursement1: parseFloat(formData.emp_Reimbursement1) || 0,
      emp_Reimbursement2: parseFloat(formData.emp_Reimbursement2) || 0,
      miscellaneous1: parseFloat(formData.miscellaneous1) || 0,
      miscellaneous2: parseFloat(formData.miscellaneous2) || 0,
      flex_Pay1: parseFloat(formData.flex_Pay1) || 0,
      flex_Pay2: parseFloat(formData.flex_Pay2) || 0,
      loan_Repayment1: parseFloat(formData.loan_Repayment1) || 0,
      loan_Repayment2: parseFloat(formData.loan_Repayment2) || 0,
      meal_Allowance1: parseFloat(formData.meal_Allowance1) || 0,
      meal_Allowance2: parseFloat(formData.meal_Allowance2) || 0,
      auto_Allowance1: parseFloat(formData.auto_Allowance1) || 0,
      auto_Allowance2: parseFloat(formData.auto_Allowance2) || 0,
      other_Allowance1: parseFloat(formData.other_Allowance1) || 0,
      other_Allowance2: parseFloat(formData.other_Allowance2) || 0,
      commission1: parseFloat(formData.commission1) || 0,
      commission2: parseFloat(formData.commission2) || 0,
      paycheck_Tips1: parseFloat(formData.paycheck_Tips1) || 0,
      paycheck_Tips2: parseFloat(formData.paycheck_Tips2) || 0,
      phone_Allowance1: parseFloat(formData.phone_Allowance1) || 0,
      phone_Allowance2: parseFloat(formData.phone_Allowance2) || 0,
      payment_date: new Date()
    };

    console.log("Parsed formData", parsedFormData);

    UserService.UpdateUserTimesheets(parsedFormData)
      .then((result: any | null) => {
        if (result !== null) {
          toast.success("Timesheet updated", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
          formData.payroll_id = result.payroll_id;
          this.setState({ isSpinner: false ,formData});
        }
      })
      .catch((error: any) => {
        console.error("Update failed err:", error);
        toast.error("Failed to update timesheet", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        this.setState({ isSpinner: false });
      });
  };

  
  handleInputChange = (field) => (event) => {
    const value = event.target ? event.target.value : event;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: field == "notes" ? value :  Utils.removeInvaildCharFromAmount(value),
      },
    }));
  };

  shownewslideout = () => {
    this.setState({
      showSlideout: true,
    });
  };

  showslideout = () => {
    this.setState({ showSlideout: true, isSpinner: false });
  };

  closeSlideOut = () => {
    this.props.closeSlideOut();
  };

  handleSelect = (key: string | null) => {
    this.setState({ taboption: key || "first" });
  };

  updateMultiSelectItem = (selectedItem: any) => {
    const { formData } = this.state;

    const selectedItems = selectedItem.map((item) => ({
      id: formData.reportid,
      reportSchId: formData.reportid,
      roleId: item.value,
      tenantid: item.tenantid || 0,
    }));

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        reportRoleSchedule: [selectedItems],
      },
    }));
  };

  multiSelectOpen = () => {
    $("#schedulerightpanelbody").animate(
      { scrollTop: $(document).height() },
      1500
    );
  };
  dataChange = () => {};

  calculateTotalHours = () => {
    const {
      ot = 0,
      dot = 0,
      regular1 = 0,
      regular2 = 0,
    } = this.state.formData;

    const sum = [ot, regular1, dot, regular2]
      .map((v) => parseFloat(v) || 0)
      .reduce((a, b) => a + b, 0);

    return sum.toFixed(2);
  };

  render() {
    const { biWeekly ,lock} = this.props;

    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );

    return (
      <section>
        <div
          className="details-drawer"
          style={{
            minWidth: "75%",
            width: "992px",
            maxWidth: "100%",
          }}
        >
          <div
            className="back-drop1  viewer-panel1 opacity "
            style={{ minWidth: "25%", maxWidth: "100%", height: "100vh" }}
            // onClick={() => this.closeSlideOut()}
          ></div>

          <Container
            fluid
            ref={this.parentScroll}
            className="body-sec viewer-panel back-drop p-2"
            style={{
              minWidth: "50%",
              width: "791px",
              maxWidth: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="page-heading  d-flex ">
              <div className="mx-3  rounded p-2">
                {this.props.laborData.firstName}({this.props.laborData.empCode})
              </div>
              <div className="d-flex flex-row ml-auto">
                <button
                  type="button"
                  className="btn btn-primary cross"
                  onClick={this.closeSlideOut}
                  style={{ marginLeft: "10px" }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                      fill="#ffffff"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div
              className="scroll"
              style={{ flex: 1, paddingBottom: "20px" }}
            >
              <section>
                <div className="col g-3 m-3">
                  {biWeekly && (
                    <div className="col-md-10">
                      <div className="row g-3 align-items-center">
                        <div className="col-md-4"></div>
                        <div className="col-md-8">
                          <div
                            className="row justify-content-center text-center"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div className="col-md-6 d-flex justify-content-center">
                              <Form.Label
                                className="font-semibold mb-0"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Week 1
                              </Form.Label>
                            </div>
                            <div className="col-md-6 d-flex justify-content-center">
                              <Form.Label
                                className="font-semibold mb-0"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Week 2
                              </Form.Label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-md-10 mt-2">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Regular
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Hrs
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.regular1}
                                  onChange={this.handleInputChange("regular1")}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Hrs
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.regular2}
                                    onChange={this.handleInputChange(
                                      "regular2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

             

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">OT</Form.Label>
                      </div>
                      <div className={biWeekly ? 'col-md-8' : 'col-md-4'}>
                        <Form.Group controlId="externalCustomerPO">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Form.Label
                              className="font-semibold mb-0"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Hrs
                            </Form.Label>
                            <Form.Control
                              // tabIndex={this.state.tabEnable}
                              id="txtExternalCustomerPO"
                              type="text"
                              placeholder=""
                              value={this.state.formData.ot}
                              onChange={this.handleInputChange("ot")}
                              autoComplete="off"
                              disabled={lock}
                              title=""
                            />
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>

  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">DOT</Form.Label>
                      </div>
                      <div className={biWeekly ? 'col-md-8' : 'col-md-4'}>
                        <Form.Group controlId="externalCustomerPO">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Form.Label
                              className="font-semibold mb-0"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Hrs
                            </Form.Label>
                            <Form.Control
                              // tabIndex={this.state.tabEnable}
                              id="txtExternalCustomerPO"
                              type="text"
                              placeholder=""
                              value={this.state.formData.dot}
                              onChange={this.handleInputChange("dot")}
                              autoComplete="off"
                              disabled={lock}
                              title=""
                            />
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-10  mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold mb-0">
                          Total Hrs.
                        </Form.Label>
                      </div>
                      <div className={biWeekly ? 'col-md-8' : 'col-md-4'}>
                        <Form.Group controlId="externalCustomerPO">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Form.Label
                              className="font-semibold mb-0"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Hrs
                            </Form.Label>
                            <Form.Control
                              id="txtExternalCustomerPO"
                              type="text"
                              placeholder=""
                              value={this.calculateTotalHours()}
                              onChange={this.handleInputChange("totalHrs")}
                              autoComplete="off"
                              disabled={true}
                              title=""
                            />
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Holiday
                        </Form.Label>
                      </div>
                      <div className={biWeekly ? 'col-md-8' : 'col-md-4'}>
                        <Form.Group controlId="externalCustomerPO">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Form.Label
                              className="font-semibold mb-0"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Hrs
                            </Form.Label>
                            <Form.Control
                              // tabIndex={this.state.tabEnable}
                              id="txtExternalCustomerPO"
                              type="text"
                              placeholder=""
                              value={this.state.formData.holiday}
                              onChange={this.handleInputChange("holiday")}
                              autoComplete="off"
                              disabled={lock}
                              title=""
                            />
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Vacation
                        </Form.Label>
                      </div>
                      <div className={biWeekly ? 'col-md-8' : 'col-md-4'}>
                        <Form.Group controlId="externalCustomerPO">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Form.Label
                              className="font-semibold mb-0"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Hrs
                            </Form.Label>
                            <Form.Control
                              // tabIndex={this.state.tabEnable}
                              id="txtExternalCustomerPO"
                              type="text"
                              placeholder=""
                              value={this.state.formData.vacation}
                              onChange={this.handleInputChange("vacation")}
                              autoComplete="off"
                              disabled={lock}
                              title=""
                            />
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">Sick</Form.Label>
                      </div>
                      <div className={biWeekly ? 'col-md-8' : 'col-md-4'}>
                        <Form.Group controlId="externalCustomerPO">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Form.Label
                              className="font-semibold mb-0"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Hrs
                            </Form.Label>
                            <Form.Control
                              // tabIndex={this.state.tabEnable}
                              id="txtExternalCustomerPO"
                              type="text"
                              placeholder=""
                              value={this.state.formData.sick}
                              onChange={this.handleInputChange("sick")}
                              autoComplete="off"
                              disabled={lock}
                              title=""
                            />
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Differential Pay
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.differential_Pay1}
                                  onChange={this.handleInputChange(
                                    "differential_Pay1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={
                                      this.state.formData.differential_Pay2
                                    }
                                    onChange={this.handleInputChange(
                                      "differential_Pay2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">Bonus</Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.bonus1}
                                  onChange={this.handleInputChange("bonus1")}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.bonus2}
                                    onChange={this.handleInputChange("bonus2")}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Retroactive
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.retroactive1}
                                  onChange={this.handleInputChange(
                                    "retroactive1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.retroactive2}
                                    onChange={this.handleInputChange(
                                      "retroactive2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Emp Reimbursement
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.emp_Reimbursement1}
                                  onChange={this.handleInputChange(
                                    "emp_Reimbursement1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={
                                      this.state.formData.emp_Reimbursement2
                                    }
                                    onChange={this.handleInputChange(
                                      "emp_Reimbursement2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Miscellaneous
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.miscellaneous1}
                                  onChange={this.handleInputChange(
                                    "miscellaneous1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.miscellaneous2}
                                    onChange={this.handleInputChange(
                                      "miscellaneous2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Flex Pay
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.flex_Pay1}
                                  onChange={this.handleInputChange("flex_Pay1")}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.flex_Pay2}
                                    onChange={this.handleInputChange(
                                      "flex_Pay2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Loan Repayment
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.loan_Repayment1}
                                  onChange={this.handleInputChange(
                                    "loan_Repayment1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.loan_Repayment2}
                                    onChange={this.handleInputChange(
                                      "loan_Repayment2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Meal Allowance
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.meal_Allowance1}
                                  onChange={this.handleInputChange(
                                    "meal_Allowance1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.meal_Allowance2}
                                    onChange={this.handleInputChange(
                                      "meal_Allowance2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Auto Allowance
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.auto_Allowance1}
                                  onChange={this.handleInputChange(
                                    "auto_Allowance1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.auto_Allowance2}
                                    onChange={this.handleInputChange(
                                      "auto_Allowance2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Other Allowance
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.other_Allowance1}
                                  onChange={this.handleInputChange(
                                    "other_Allowance1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.other_Allowance2}
                                    onChange={this.handleInputChange(
                                      "other_Allowance2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Commission
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.commission1}
                                  onChange={this.handleInputChange(
                                    "commission1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.commission2}
                                    onChange={this.handleInputChange(
                                      "commission2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Paycheck Tips - 2
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.paycheck_Tips1}
                                  onChange={this.handleInputChange(
                                    "paycheck_Tips1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.paycheck_Tips2}
                                    onChange={this.handleInputChange(
                                      "paycheck_Tips2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">
                          Phone Allowance
                        </Form.Label>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group controlId="externalCustomerPO">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Form.Label
                                  className="font-semibold mb-0 p-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  $
                                </Form.Label>
                                <Form.Control
                                  // tabIndex={this.state.tabEnable}
                                  id="txtExternalCustomerPO"
                                  type="text"
                                  placeholder=""
                                  value={this.state.formData.phone_Allowance1}
                                  onChange={this.handleInputChange(
                                    "phone_Allowance1"
                                  )}
                                  autoComplete="off"
                                  disabled={lock}
                                  title=""
                                />
                              </div>
                            </Form.Group>
                          </div>
                          {biWeekly && (
                            <div className="col-md-6">
                              <Form.Group controlId="externalCustomerPO">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <Form.Label
                                    className="font-semibold mb-0 p-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    $
                                  </Form.Label>
                                  <Form.Control
                                    // tabIndex={this.state.tabEnable}
                                    id="txtExternalCustomerPO"
                                    type="text"
                                    placeholder=""
                                    value={this.state.formData.phone_Allowance2}
                                    onChange={this.handleInputChange(
                                      "phone_Allowance2"
                                    )}
                                    autoComplete="off"
                                    disabled={lock}
                                    title=""
                                  />
                                </div>
                              </Form.Group>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-10 mt-1">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <Form.Label className="font-semibold">Notes</Form.Label>
                      </div>
                      <div className="col-md-8">
                        <Form.Group controlId="externalCustomerPO">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Form.Label
                              className="font-semibold mb-0"
                              style={{ whiteSpace: "nowrap", padding: "12px" }}
                            ></Form.Label>
                            <Form.Control
                              id="txtaddress"
                              as="textarea"
                              className="txtarea"
                              rows={3}
                              placeholder=""
                              value={this.state.formData.notes}
                              onChange={this.handleInputChange("notes")}
                              autoComplete="off"
                              disabled={lock}
                              title=""
                            />
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="filter-sec height-172">

                                <br></br>
                                <br></br>

                              </div>
            </div>

            <div
              className={"footer-section viewer-panel mt-3"}
              style={{ minWidth: "50%", width: "791px", maxWidth: "100%" }}
            >
              <div className="d-flex gap-3 align-items-center justify-content-end height-72">
                <div className="d-flex gap-3 align-items-center">
                  {/* {this.state.isStateChanged && ( */}
                  <>
                    <Button
                      variant="primary"
                      type="button"
                      className="space btn btn-primary btn-discard"
                      onClick={this.closeSlideOut}
                    >
                      Discard
                    </Button>
                    <Button
                      id="btnSave"
                      variant="primary"
                      type="button"
                      onClick={this.saveItem}
                    >
                      {"Save"}
                    </Button>
                  </>
                  {/* )} */}
                </div>
              </div>
            </div>
          </Container>

          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

          {/* {this.state.showDetailedReport && <DetailedReport closeSlideout={()=>{this.setState({showDetailedReport:false});}} />} */}
          {/* <DetailedReport
            show={this.state.showDetailedReport}
            reportId={this.state.reportId}
            ReportName={this.state.reportName}
            onHide={() => {
              this.setState({ showDetailedReport: false });
            }}
          /> */}
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});


export default connect(mapStateToProps)(LaborSlideout);